// theme.ts
import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import { PaletteMode } from '@mui/material'
import '@fontsource-variable/raleway'

// const raleway = Raleway({ subsets: ['latin'], variable: '--font-raleway' })

export const getDesignTokens = (mode: PaletteMode) => ({
    palette: {
        mode,
        primary: {
            main: '#1BAA60',
        },
        secondary: {
            main: '#3F51B5',
        },
        background: {
            default: mode === 'light' ? '#fafafa' : '#121212',
            paper: mode === 'light' ? '#fff' : '#1E1E1E',
        },
    },
    shape: {
        borderRadius: 8,
    },
    typography: {
        fontFamily: ['Raleway Variable', 'Helvetica Neue', 'Arial', 'sans-serif'].join(','),
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 700,
                    borderRadius: 12,
                    padding: '8px 20px',
                },
                containedPrimary: {
                    backgroundColor: '#1BAA60',
                    '&:hover': {
                        backgroundColor: '#169C56',
                    },
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 700,
                },
            },
        },
    },
})

export const createFootoryTheme = (mode: PaletteMode) =>
    responsiveFontSizes(createTheme(getDesignTokens(mode) as any))
